import Cookies from "js-cookie";
export const getHeaders = (isFormData = false) => ({
  "Content-Type": isFormData ? "multipart/form-data" : "application/json",
  Accept: "application/json",
  lang: Cookies.get("zado_lng"), // إضافة اللغة
  Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
});
